import { Injectable } from '@angular/core';
import { AuthService } from './auth.service';
import * as Parse from 'parse';

export type SortDirection = 'views-desc' | 'views-asc' | 'clicks-desc' | 'clicks-asc';

@Injectable()
export class MarketingService {

    constructor(private auth: AuthService) {
    }

    fetchMarketingCampaigns(property: Parse.Object) {
        const query: Parse.Query<Parse.Object> = new Parse.Query('MarketingCampaign');

        query.equalTo('property', property);
        query.equalTo('organization', property.get('organization'));
        query.descending('createdAt');
        // query.notEqualTo('sentTotal', 0);

        // query.withCount();

        if (this.auth.userType === 'Admin' || this.auth.userType === 'AA') {
            query.include('owner');
        }

        return query.find();
    }

    fetchCampaignReport() {

    }

    sendMailchimpCampaignToAllCustomers(propertyId: string) {
        return Parse.Cloud.run('sendMailchimpCampaignToAllCustomers', {
            propertyId: propertyId
        });
    }

    sendMailchimpCampaignToMailingList(propertyId: string, userId: string) {
        return Parse.Cloud.run('sendMailchimpCampaignToMailingList', {
            propertyId: propertyId,
            userId: userId
        });
    }

    isJobDone(jobId: string) {
        return Parse.Cloud.run('isJobDone', {
            jobId: jobId
        });
    }

    initEngagementOverviewFetch(property: Parse.Object) {
        return Parse.Cloud.run('initEngagementOverviewFetch', {
            property: property.toPointer()
        });
    }

    initUserReportFetch(campaign: Parse.Object) {
        return Parse.Cloud.run('initUserReportFetch', {
            campaignId: campaign.id
        });
    }

    fetchCustomerOwners(customersToFetch: string[]) {
        return Parse.Cloud.run('fetchCustomerOwners', {
            customerIds: customersToFetch
        });
    }

    fetchPinpointCampaignReport(campaignId: string, organizationId: string, pageIndex: number, pageSize: number, sort?: SortDirection | null) {
        return Parse.Cloud.run('fetchPinpointCampaignReport', {
            campaignId: campaignId,
            organizationId: organizationId,
            pageSize: pageSize,
            pageIndex: pageIndex,
            sort: sort
        });
    }

    fetchMailchimpCampaignReport(campaignId: string, organizationId: string, pageIndex: number, pageSize: number, sort?: SortDirection | null) {
        return Parse.Cloud.run('fetchMailchimpCampaignReport', {
            campaignId: campaignId,
            organizationId: organizationId,
            pageSize: pageSize,
            pageIndex: pageIndex,
            sort: sort
        });
    }

    getAgents(organization: Parse.Object) {
        const query: Parse.Query<Parse.User> = new Parse.Query(Parse.User);

        query.equalTo('organization', organization);
        query.notEqualTo('objectId', this.auth.currentUser.id);
        query.containedIn('type', ['Admin', 'AA', 'SA']);

        return query.find();
    }
}
